// extracted by mini-css-extract-plugin
export default {"topic":"create-event_topic__AO3Jz","keyWords":"create-event_keyWords__nu9vP"};